export const config = {
  shunno_pay_base_url: "https://shunnoit.top/shunno-payment/api/v1",
  shunno_pay_token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtanRvbGxkdSIsImlhdCI6MTc2NzE2NTMxMSwiZXhwIjo5MDA3MTk5MjU0NzQwOTkxLCJ0eXBlIjoiQVBJX0tFWSJ9.lh76kItWZF6M1L7Dx1tIGFjLKbJNCz454H3UgLdOwac",
  file_upload_url: "https://shunnoit.top/fms/",
};
